import React, { useEffect } from "react";
import "./organization-settings-hero.scss";

import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import {
  faChevronLeft,
  faExternalLinkSquareAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {
  selectCurrentOrganization,
  setSelectedOrganization,
  saveOrganization,
  clearNotifications,
  selectOrganizationNotifications,
  selectOrganization,
} from "../../reducers/organizationSlice";
import {
  clearUtilityNotifications,
  selectCroppedImage,
  selectCroppedTarget,
  selectUtilityNotifications,
  setCroppedImage,
  setUploadedFile,
} from "../../reducers/utilitySlice";
import { getHeroForm } from "../../forms/SettingsForm";
import { useFormDataValidation, useImageSelector } from "../../hooks/formHooks";
import { useNotificationBanner } from "../../hooks/notificationHooks";

const OrganizationSettingsHero = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const croppedTarget = useSelector(selectCroppedTarget);
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const utilNotifications = useSelector(selectUtilityNotifications);
  const croppedImage = useSelector(selectCroppedImage);

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValue: false,
    data: selectedOrganization,
    setData: setSelectedOrganization,
  });

  const [, , setLogo, removeLogo, getLogo, ,] = useImageSelector(
    context,
    "bannerImage"
  );

  const setImage = (files) => {
    const file = files[0];
    const fr = new FileReader(file);
    fr.onload = (e) => {
      if (e) {
        dispatch(setCroppedImage(e.currentTarget.result));
      }
    };
    fr.readAsDataURL(file);
  };

  context.getLogo = getLogo;
  context.setLogo = (files) => {
    setImage(files);
    setLogo(files);
  };
  context.removeLogo = removeLogo;

  useEffect(() => {
    if (croppedTarget?.bannerImage) {
      setIsValid(true);
    }
  }, [croppedTarget?.bannerImage, setIsValid]);

  const sendUpdate = () => {
    let payload = {
      ...selectedOrganization,
      bannerImage: croppedImage ?? selectedOrganization.bannerImage,
    };
    dispatch(saveOrganization(payload));
  };

  const leftNavigation = () => {
    dispatch(selectOrganization(selectedOrganization.id));
    dispatch(setUploadedFile(""));
    dispatch(clearNotifications());
    dispatch(clearUtilityNotifications());
    navigate(-1);
  };

  const saveOrg = () => {
    sendUpdate();
    setIsValid(false);
  };

  context.validationFailed = () => {
    if (isValid) {
      setIsValid(false);
    }
  };

  context.removeImage = () => {
    removeLogo("bannerImage");
  };

  context.formIsValid = () => {
    return isValid;
  };

  context.editImage = () => {
    navigate("./edit/image");
  };

  const getActions = () => {
    return [
      {
        name: "Save",
        isDisabled: !isValid,
        action: saveOrg,
        type: "black",
      },

      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
  };

  const goToEventsList = () => {
    window.open(
      `${process.env.REACT_APP_GOLFSTATUS_EVENTS_BASE_URL}/organization/${selectedOrganization.id}`
    );
  };

  const getHeaderActions = () => {
    return [
      {
        title: "View Events List",
        rightIcon: faExternalLinkSquareAlt,
        actionClick: goToEventsList,
        type: "light-grey no-wrap mobile-icon",
      },
    ];
  };

  const getNavigation = () => {
    return {
      title: "Banner Image",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
    dispatch(clearUtilityNotifications());
  };

  const getBannerActions = (notification) => {
    if (notification[0]?.state === "success") {
      return [
        {
          id: 1,
          title: "View Events List",
          size: "secondary",
          actionClick: goToEventsList,
        },
      ];
    }
  };

  let notificationSettings = {
    notifications: [...orgNotifications, ...utilNotifications],
    bannerActions: getBannerActions([...orgNotifications]),
    timeoutAction,
  };

  const [bannerNotifications] = useNotificationBanner(notificationSettings);

  const getContent = () => {
    return (
      <GSForm
        formTitle="Banner Image"
        formActions={getHeaderActions()}
        formSections={getHeroForm(context, selectedOrganization)}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };

  return (
    <organization-settings-hero>
      <GSSidePanelPage
        header={getNavigation()}
        banner={bannerNotifications}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-settings-hero>
  );
};

export default OrganizationSettingsHero;
